export default {
    namespaced: true,

    state: {
        task: {},
    },

    getters: {
        task: (state) => state.task,
    },

    mutations: {
        SET_TASK: (state, payload) => {
            state.task = payload;
        },
    },
    actions: {
        setTask({ commit }, item) {
            commit("SET_TASK", item)
        },
    }
};
